var manifest = null
var requestGeneration = 0
var activeRequestController = null
var forcedRootIds = {}
var pendingSyncTimer = null

var readManifest = function () {
	if (manifest !== null) return manifest
	manifest = {}
	var script = document.getElementById('lay-page-overlays-manifest')
	if (!script) return manifest

	try {
		var parsed = JSON.parse(script.textContent || '{}')
		if (parsed && typeof parsed == 'object') {
			manifest = parsed
		}
	} catch (error) {}

	return manifest
}

var normalizePath = function (url) {
	if (!url || url.charAt(0) == '#') return ''
	try {
		var parsed = new URL(url, window.location.href)
		var path = decodeURIComponent(parsed.pathname || '/')
		path = path.replace(/^\/[a-z]{2,3}\//i, '/')
		if (path.length > 1) path = path.replace(/\/+$/, '')
		return path
	} catch (error) {
		return ''
	}
}

var getEntryForLink = function (link, href) {
	var entries = readManifest()
	var id = link && link.getAttribute ? link.getAttribute('data-id') : ''
	var type = link && link.getAttribute ? link.getAttribute('data-type') : ''
	if (type == 'page' && id && entries[String(id)]) {
		return entries[String(id)]
	}

	var hrefPath = normalizePath(href)
	if (!hrefPath) return null
	var keys = Object.keys(entries)
	for (var i = 0; i < keys.length; i++) {
		var entry = entries[keys[i]]
		if (entry && normalizePath(entry.url) == hrefPath) {
			return entry
		}
	}
	return null
}

var getRootOverlayIds = function () {
	var entries = readManifest()
	var ids = {}
	var links = document.querySelectorAll('a[href]')
	for (var i = 0; i < links.length; i++) {
		var link = links[i]
		if (link.closest && link.closest('#lay-overlays')) continue
		var entry = getEntryForLink(link, link.getAttribute('href'))
		if (entry && entry.id) ids[String(entry.id)] = true
	}

	Object.keys(entries).forEach(function (key) {
		var entry = entries[key]
		if (entry && (entry.burger || entry.preopen)) ids[String(entry.id)] = true
	})
	Object.keys(forcedRootIds).forEach(function (key) {
		if (forcedRootIds[key]) ids[String(key)] = true
	})

	return Object.keys(ids).map(function (id) {
		return parseInt(id, 10)
	})
}

var getScopedManifestIds = function () {
	var entries = readManifest()
	return Object.keys(entries)
		.filter(function (key) {
			return entries[key] && entries[key].loadOnlyWhenOpenable
		})
		.map(function (key) {
			return parseInt(key, 10)
		})
}

var removeScopedOverlayMarkup = function () {
	getScopedManifestIds().forEach(function (id) {
		var selectors = [
			'.overlay-id-' + id,
			'.overlay-bg-id-' + id,
			'.overlay-close-id-' + id,
			'.burger-overlay-id-' + id,
		]
		jQuery('#lay-overlays').find(selectors.join(',')).remove()
	})
	jQuery('#lay-overlays style[data-lay-page-overlay-dynamic-style="1"]').remove()
}

var pageOverlayIsOpen = function () {
	return document.querySelector('.lay-overlay.display-block-overlay, .lay-overlay.lay-show-overlay') !== null
}

var applyMarkup = function (markup, generation) {
	if (generation != requestGeneration) return false
	if (pageOverlayIsOpen()) return false

	removeScopedOverlayMarkup()
	if (markup) {
		jQuery('#lay-overlays').append(markup)
	}
	window.laytheme.emit('page_overlay_markup_ready', jQuery('#lay-overlays'))
	return true
}

var getRequestLanguage = function () {
	if (window.layCachePreload && typeof window.layCachePreload.getUrlLangForRequest == 'function') {
		return window.layCachePreload.getUrlLangForRequest(window.location.href) || ''
	}
	return ''
}

var fetchReachableMarkup = function () {
	var generation = ++requestGeneration
	if (activeRequestController && typeof activeRequestController.abort == 'function') {
		activeRequestController.abort()
	}
	activeRequestController = typeof AbortController == 'function' ? new AbortController() : null

	var body = new URLSearchParams()
	body.set('action', 'get_laytheme_page_overlays')
	body.set('ids', JSON.stringify(getRootOverlayIds()))
	var lang = getRequestLanguage()
	if (lang) body.set('lang', lang)

	return fetch(layData.ajax_url, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		},
		body: body.toString(),
		signal: activeRequestController ? activeRequestController.signal : undefined,
	})
		.then(function (response) {
			if (!response.ok) throw new Error('Page overlay request failed')
			return response.json()
		})
		.then(function (json) {
			if (!json || json.success !== true || !json.data) throw new Error('Invalid page overlay response')
			if (!applyMarkup(json.data.markup || '', generation)) {
				scheduleSync()
			}
			return json.data
		})
		.catch(function (error) {
			if (error && error.name == 'AbortError') return null
			throw error
		})
}

var scheduleSync = function () {
	if (pendingSyncTimer !== null) window.clearTimeout(pendingSyncTimer)
	pendingSyncTimer = window.setTimeout(function () {
		pendingSyncTimer = null
		if (!pageOverlayIsOpen()) {
			fetchReachableMarkup().catch(function () {})
		}
	}, 0)
}

var openIfKnown = function (link, href, openOverlay) {
	var entry = getEntryForLink(link, href)
	if (!entry || !entry.id) return false

	forcedRootIds[String(entry.id)] = true
	fetchReachableMarkup()
		.then(function () {
			// The clicked href may have been decorated by WooCommerce geolocation
			// or analytics (for example ?v=... or _gl=...). Overlay markup uses the
			// canonical manifest URL, so use that URL for matching and keep the
			// clicked href only as the full-page fallback.
			var overlayHref = entry.url || href
			if (typeof openOverlay == 'function' && openOverlay(overlayHref)) return
			window.location.href = href
		})
		.catch(function () {
			window.location.href = href
		})
	return true
}

var i = function () {
	readManifest()
	window.laytheme.on('newpageshown', scheduleSync)
	window.laytheme.on('project_overlay_open_start', scheduleSync)
	window.laytheme.on('project_overlay_open_end', scheduleSync)
	window.laytheme.on('destroyoverlay', scheduleSync)
	window.laytheme.on('overlayhidden', function () {
		forcedRootIds = {}
		scheduleSync()
	})
}

var page_overlay_loader = {
	i: i,
	openIfKnown: openIfKnown,
	scheduleSync: scheduleSync,
	getManifest: readManifest,
}

export default page_overlay_loader
